import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon_user@2x.png';
import _imports_1 from '@/assets/icon_password@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-64f236fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "center"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
import options, { particlesInit } from "@/utils/options";
import { reactive, ref, onMounted } from "vue";
import { useStore } from "@/store/index";
import { useI18n } from "vue-i18n";
import CryptoJS from "crypto-js";
import Cookie from "js-cookie";
export default {
  __name: 'index',
  setup(__props) {
    const {
      t
    } = useI18n();
    const store = useStore();
    const input = reactive({
      username: "",
      password: "",
      rememberMe: false
    });
    const Form = ref(null);
    const flag = ref(true);
    let loading = ref(false);
    // 正则校验
    const rules = {
      username: [{
        required: true,
        trigger: "blur",
        message: t("common.pleaseEnter", {
          val: t("info.account")
        })
      }],
      password: [{
        required: true,
        trigger: "blur",
        message: t("common.pleaseEnter", {
          val: t("common.password")
        })
      }]
    };
    const onSubmit = () => {
      // 校验表单数据
      Form.value.validate(async valid => {
        if (!valid) return;
        loading.value = true;
        try {
          await store.getLogin(input);
        } finally {
          loading.value = false;
        }
        // 缓存
        if (input.rememberMe) {
          const encryptedPassword = CryptoJS.AES.encrypt(input.password, "your-secret-key").toString();
          Cookie.set("username", input.username, {
            expires: 30
          });
          Cookie.set("password", encryptedPassword, {
            expires: 30
          });
          Cookie.set("rememberMe", input.rememberMe, {
            expires: 30
          });
        } else {
          Cookie.remove("username");
          Cookie.remove("password");
          Cookie.remove("rememberMe");
        }
      });
    };
    const getCookie = () => {
      const userName = Cookie.get("username") ?? ""; // 获取用户名或设置为空字符串
      const password = Cookie.get("password"); // 获取加密的密码
      const rememberMe = Cookie.get("rememberMe") === "true"; // 将rememberMe转为布尔值
      input.username = userName;
      // 如果有存储的密码，解密后赋值；否则为空字符串
      input.password = password ? CryptoJS.AES.decrypt(password, "your-secret-key").toString(CryptoJS.enc.Utf8) ?? "" : "";
      input.rememberMe = rememberMe;
    };
    onMounted(() => {
      getCookie();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_Particles = _resolveComponent("Particles");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("common.service")), 1), _withDirectives(_createVNode(_component_el_form, {
        ref_key: "Form",
        ref: Form,
        model: input,
        rules: rules,
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: input.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => input.username = $event),
            placeholder: _ctx.$t('common.inputUsername')
          }, null, 8, ["modelValue", "placeholder"]), _hoisted_4]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: input.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => input.password = $event),
            "show-password": "",
            placeholder: _ctx.$t('common.inputPassword')
          }, null, 8, ["modelValue", "placeholder"]), _hoisted_5]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            label: _ctx.$t('common.rememberPassword'),
            modelValue: input.rememberMe,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => input.rememberMe = $event)
          }, null, 8, ["label", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: _unref(loading),
            type: "primary",
            style: {
              "width": "100%",
              "height": "40px"
            },
            "native-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.login")), 1)]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), [[_vShow, flag.value]])]), _createVNode(_component_Particles, {
        id: "tsparticles",
        particlesInit: _unref(particlesInit),
        options: _unref(options)
      }, null, 8, ["particlesInit", "options"])]);
    };
  }
};